var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('aside',[_c('b-icon',{attrs:{"icon":_vm.icon}})],1),_vm._v(" "),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }